export default __webpack_public_path__ + "static/media/staking-arrows.f733d5a0.png";